import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { LogsPanel } from "@/components/admin/LogsPanel";

export const Route = createFileRoute("/_authenticated/admin/logs")({
  head: () => ({
    meta: [
      { title: "Админ — Logs | FIXHEN" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  validateSearch: z.object({
    corr: z.string().optional(),
    correlation_id: z.string().optional(),
    session_id: z.string().optional(),
    tab: z.string().optional(),
  }).parse,
  component: () => (
    <AdminLayout>
      <LogsPanel />
    </AdminLayout>
  ),
});